import { ROLE } from '@datacloud-incubation/frontend-ai-chat-module';
import { FLOW_CHAT_EVENTS } from '../constants/flowChat.constant';
import type { TReducerAction, TReducerState } from '../models/flowChat.model';

const initialState: TReducerState = {
  sessionMetadata: {
    sessionId: '',
    content: '',
    isComplete: false
  },
  messages: []
};

const reducer = (state: TReducerState, action: TReducerAction) => {
  switch (action.event) {
    case FLOW_CHAT_EVENTS.idle:
      return { ...state, messages: action.data };

    case FLOW_CHAT_EVENTS.userMessage:
      return {
        ...state,
        messages: [...state.messages, action.data]
      };

    case FLOW_CHAT_EVENTS.messageStart:
      return {
        ...state,
        messages: [
          ...state.messages,
          {
            id: action.data.messageId,
            role: ROLE.assistant,
            content: '',
            created: '',
            createdAt: '',
            session: '',
            sessionId: ''
          }
        ]
      };

    case FLOW_CHAT_EVENTS.titleStart:
      return {
        sessionMetadata: {
          sessionId: action.data.sessionId,
          content: '',
          isComplete: false
        },
        messages: state.messages.map((msg, index, arr) =>
          index === arr.length - 1
            ? { ...msg, session: action.data.sessionId, sessionId: action.data.sessionId }
            : msg
        )
      };

    case FLOW_CHAT_EVENTS.titleDelta:
      return {
        ...state,
        sessionMetadata: {
          ...state.sessionMetadata,
          content: state.sessionMetadata.content.concat('', action.data.content)
        }
      };

    case FLOW_CHAT_EVENTS.titleStop:
      return {
        ...state,
        sessionMetadata: {
          ...state.sessionMetadata,
          isComplete: state.sessionMetadata.content.length > 0
        }
      };

    case FLOW_CHAT_EVENTS.messageDelta:
      return {
        ...state,
        messages: state.messages.map((msg, index, arr) =>
          index === arr.length - 1 ? { ...msg, content: msg.content + action.data.content } : msg
        )
      };

    case FLOW_CHAT_EVENTS.messageStop:
      return {
        ...state,
        messages: state.messages.map((msg, index, arr) =>
          index === arr.length - 1
            ? {
                ...msg,
                created: action.data.createdAt,
                createdAt: action.data.createdAt,
                responseTime: action.data.responseTime
              }
            : msg
        )
      };

    case FLOW_CHAT_EVENTS.complete:
      return {
        ...state,
        messages: state.messages.map((msg, index, arr) =>
          index === arr.length - 1
            ? { ...msg, liked: false, disliked: false, dislikeMessage: null }
            : msg
        )
      };

    case FLOW_CHAT_EVENTS.error: {
      if (
        action.data?.message === 'aborted' &&
        action.data?.error === 'AbortError' &&
        state.messages.at(-1)?.role === ROLE.assistant &&
        !state.messages.at(-1)?.content
      ) {
        return { ...state, messages: state.messages.slice(0, -1) };
      }

      return state;
    }

    default:
      return state;
  }
};

export { reducer, initialState };
